
style= require('./edit-formations.styl')

.formations-wrapper
  .formations-header
    .team-info.home-team
      .team-badge
        if match?.homeTeam?.logo
          img(src=match.homeTeam.logo)
        else
          .badge-placeholder= match?.homeTeam?.name.charAt(0)
      .team-details
        .team-name= match?.homeTeam?.name
        .selected-count= `${this.playerFormations[this.homeTeamId]?.size || 0} / 11`
      .formation-wrapper
        .formation-label FORMATION
        ft-select.formation-select(
          [value]= this.formations[match.homeTeam._id],
          (change)= this.updateFormation(match.homeTeam._id, e.target.value)
        )
          option(value='') Select Formation
          each formation in formationVariants
            option(value=formation)= formation

    ft-button(
      warning,
      disabled=this.isSaveDisabled,
      (click)=this.saveFormations()
    ) Save

    .team-info.away-team
      .formation-wrapper
        .formation-label FORMATION
        ft-select.formation-select(
          [value]= this.formations[match.awayTeam._id],
          (change)= this.updateFormation(match.awayTeam._id, e.target.value)
        )
          option(value='') Select Formation
          each formation in formationVariants
            option(value=formation)= formation
      .team-details
        .team-name= match?.awayTeam?.name
        .selected-count= `${this.playerFormations[this.awayTeamId]?.size || 0} / 11`
      .team-badge
        if match?.awayTeam?.logo
          img(src=match.awayTeam.logo)
        else
          .badge-placeholder.away= match?.awayTeam?.name.charAt(0)

  .field-container
    .field-background
      .team-formation.home-formation
        each line in homeFormationLines
          .position-column
            each slotIndex in line
              - var selectedPlayer = this.getSelectedPlayer(this.homeTeamId, slotIndex)
              .player-slot
                .player-circle(
                  (click)= this.openPlayerList('home', slotIndex)
                )= slotIndex
                if selectedPlayer
                  .player-chip
                    .player-chip-name= selectedPlayer.lastName
                    .player-chip-cross(
                      (click)= this.removePlayerSelection(this.homeTeamId, slotIndex, e)
                    ) ✕

      .team-formation.away-formation
        each line in awayFormationLines
          .position-column
            each slotIndex in line
              - var selectedPlayer = this.getSelectedPlayer(this.awayTeamId, slotIndex)
              .player-slot
                .player-circle(
                  (click)= this.openPlayerList('away', slotIndex)
                )= slotIndex
                if selectedPlayer
                  .player-chip
                    .player-chip-name= selectedPlayer.lastName
                    .player-chip-cross(
                      (click)= this.removePlayerSelection(this.awayTeamId, slotIndex, e)
                    ) ✕
